import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
// PAGES
import {
  Dashboard,
  MyProfile,
  MyCourses,
  MyCourseView,
  MyCourseLive,
  CoursesHistory,
  CourseHistoryView,
  Chat,
  Notifications,
  NotificationView,
  MyWallet,
  Invoice,
  InvoiceView,
  InviteFriends,
  Dispute,
  DisputeCreate,
  TransactionHistory,
  LeaveRequest,
  LeaveRequestCreate,
  LeaveRequestView,
  Assignment,
  AssignmentView,
  AssignmentCreate,
  Result,
  ResultView,
  Attendance
} from "./../../pages";
const StudentPanelRouterNavigation = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/student-panel/dashboard" element={<Dashboard />} />
        <Route path="/student-panel/my-profile" element={<MyProfile />} />
        <Route path="/student-panel/my-courses" element={<MyCourses />} />
        <Route
          path="/student-panel/my-courses/view"
          element={<MyCourseView />}
        />
        <Route
          path="/student-panel/my-courses/live"
          element={<MyCourseLive />}
        />
        <Route
          path="/student-panel/courses-history"
          element={<CoursesHistory />}
        />
        <Route
          path="/student-panel/courses-history/view"
          element={<CourseHistoryView />}
        />
        <Route path="/student-panel/chat" element={<Chat />} />
        <Route
          path="/student-panel/notifications"
          element={<Notifications />}
        />
        <Route
          path="/student-panel/notifications/view"
          element={<NotificationView />}
        />
        <Route path="/student-panel/my-wallet" element={<MyWallet />} />
        <Route path="/student-panel/invoice" element={<Invoice />} />
        <Route path="/student-panel/invoice/view" element={<InvoiceView />} />
        <Route
          path="/student-panel/invite-friends"
          element={<InviteFriends />}
        />
        <Route path="/student-panel/dispute" element={<Dispute />} />
        <Route
          path="/student-panel/dispute/create"
          element={<DisputeCreate />}
        />
        <Route
          path="/student-panel/transaction-history"
          element={<TransactionHistory />}
        />
        <Route path="/student-panel/leave-request" element={<LeaveRequest />} />
        <Route
          path="/student-panel/leave-request/create"
          element={<LeaveRequestCreate />}
        />
        <Route
          path="/student-panel/leave-request/view"
          element={<LeaveRequestView />}
        />
        <Route path="/student-panel/assignment" element={<Assignment />} />
        <Route
          path="/student-panel/assignment/view"
          element={<AssignmentView />}
        />
        <Route
          path="/student-panel/assignment/create"
          element={<AssignmentCreate />}
        />
        <Route path="/student-panel/result" element={<Result />} />
        <Route path="/student-panel/result/view" element={<ResultView />} />
        <Route path="/student-panel/attendance" element={<Attendance />} />
      </Routes>
    </BrowserRouter>
  );
};
export default StudentPanelRouterNavigation;
